import { render } from "./CardSpecHouse.vue?vue&type=template&id=2a75b95d"
import script from "./CardSpecHouse.vue?vue&type=script&lang=js"
export * from "./CardSpecHouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/CardSpecHouse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a75b95d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a75b95d', __exports__)) {
    api.reload('2a75b95d', __exports__)
  }
  
  module.hot.accept("./CardSpecHouse.vue?vue&type=template&id=2a75b95d", () => {
    api.rerender('2a75b95d', render)
  })

}


export default __exports__